
const state = {
    config: null,
    settime: '',
    isreadconfig: 0
  }
  const mutations = {
    SET_CONFIG: (state, data) => {
      state.config = data
    }
  }
  const actions = {
  
  }
  
  export default {
    namespaced: true,
    state,
    actions,
    mutations
  }
  